import 'whatwg-fetch';
import {ResourcesStorage} from './ResourcesStorage';
import {ResourceType} from './ResourceType';

const _parseResponce = (responce, type) => {
    return new Promise((resolve, reject) => {
        switch (type) {
            case ResourceType.NONE:
                resolve(responce.text());
                break;

            case ResourceType.MANIFEST:
                responce.json().then(
                    result => {
                        if (!result.manifest || !(result.manifest instanceof Array)) {
                            reject(null);
                            return;
                        }
                        resolve(result.manifest);
                    },
                    err => {
                        throw err;
                    }
                );
                break;

            case ResourceType.JSON:
            default:
                resolve(responce.json());
                break;
        }
    });
};

function FetchSingleResource(id, url, critical, doThat, type = ResourceType.JSON, store = true, storage = null) {
    const _storage = storage || ResourcesStorage.instance();

    return new Promise((resolve, reject) => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        const __parseResponce = type => {
            return response => {
                return _parseResponce(response, type);
            };
        };

        fetch(url)
            .then(
                response => {
                    if (!response.ok) throw new Error(`Resource ${id} (${url}) loading failed`);
                    return response;
                },
                err => {
                    throw err;
                }
            )
            .then(__parseResponce(type || ResourceType.JSON))
            .then(
                data => {
                    if (store) _storage.add(id || url, data);
                    resolve(data);
                },
                err => {
                    if (store) _storage.setNotLoaded(id || url);
                    throw err;
                }
            )
            .catch((/* err*/) => {
                // console.log(err, critical);
                if (store) _storage.setNotLoaded(id || url);
                if (critical) {
                    reject();
                    return;
                }
                resolve(null);
            });
    });
}

const FetchSingleResourceFunction = (id, url, critical, type, store, storage) => {
    return doThat => {
        return FetchSingleResource(id, url, critical, doThat, type, store, storage);
    };
};

export {FetchSingleResource, FetchSingleResourceFunction};
export default FetchSingleResource;
